/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QuantityInputs */

const en_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity`)
};

const th_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวน`)
};

const ja_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

const fr_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantité`)
};

const es_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad`)
};

const ru_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество`)
};

const zh_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

const vi_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng`)
};

/**
* | output |
* | --- |
* | "Quantity" |
*
* @param {QuantityInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const quantity = /** @type {((inputs?: QuantityInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QuantityInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_quantity(inputs)
	if (locale === "ja") return ja_quantity(inputs)
	if (locale === "fr") return fr_quantity(inputs)
	if (locale === "es") return es_quantity(inputs)
	if (locale === "ru") return ru_quantity(inputs)
	if (locale === "zh") return zh_quantity(inputs)
	if (locale === "vi") return vi_quantity(inputs)
	return en_quantity(inputs)
});